import core, { View } from '@gin-betting/core';
import { IntlFormatters } from 'react-intl';

import globalMessages from 'messages';
import getProductName from './getProductName';

const {
    utils: { format },
} = core;

function getHelmetTitle({
    match,
    tournament,
    formatMessage,
}: {
    match: Pick<View.Match, 'startTime' | 'title'> | null;
    tournament: Pick<View.Tournament, 'name'> | null;
    formatMessage: IntlFormatters['formatMessage'];
}) {
    const parts = {
        matchTitle: '',
        date: '',
        time: '',
        tournamentName: '',
    };

    if (match) {
        parts.matchTitle = match.title;
        parts.time = format(match.startTime, 'HH:mm');
        parts.date = format(match.startTime, 'dd.MM.yy');
    }

    if (tournament) {
        parts.tournamentName = tournament.name;
    }

    const { matchTitle, tournamentName, date, time } = parts;

    return formatMessage(globalMessages.matchTitle, {
        matchTitle:
            window.location.host === 'ggbet.ru'
                ? matchTitle.split('VS').join('против')
                : matchTitle,
        tournamentName,
        date,
        time,
        productName: getProductName(),
    });
}

export default getHelmetTitle;
